<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.yongxinBigTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/super_big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 0 20px 10px 20px;">
    <div class="biankuang" style="width: 100%;height: 100%;display:flex;justify-content:space-around;align-items: center;">
      <div style="display:flex;justify-content:space-around;align-items:center;">
        <img style="width: 40px;height: auto;" src="../../../../../../../assets/img/web/yongxin/运行.png" />
        <p style="font-size:20px;color:white;margin: 0px 10px;">运行</p>
        <p style="color: rgba(58, 220, 255, 1);font-weight: bold;font-size: 40px;">{{ yunxing }}</p>
      </div>
      <div style="display:flex;justify-content:space-around;align-items:center;">
        <img style="width: 40px;height: auto;" src="../../../../../../../assets/img/web/yongxin/空闲.png" />
        <p style="font-size:20px;color:white;margin: 0px 10px;">空闲</p>
        <p style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 40px;">{{ kongxian }}</p>
      </div>
      <div style="display:flex;justify-content:space-around;align-items:center;">
        <img style="width: 40px;height: auto;" src="../../../../../../../assets/img/web/yongxin/故障.png" />
        <p style="font-size:20px;color:white;margin: 0px 10px;">故障</p>
        <p style="color: rgba(255, 58, 117, 1);font-weight: bold;font-size: 40px;">{{ guzhang }}</p>
      </div>
      <div style="display:flex;justify-content:space-around;align-items:center;">
        <img style="width: 40px;height: auto;" src="../../../../../../../assets/img/web/yongxin/离线.png" />
        <p style="font-size:20px;color:white;margin: 0px 10px;">离线</p>
        <p style="color: rgba(170, 179, 204, 1);font-weight: bold;font-size: 40px;">{{ lixian }}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_count',
  components: {},

  data() {
    return {
      timer: null,
      list: [],
      yunxing: 0,
      kongxian: 0,
      guzhang: 0,
      lixian: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/report/equipment/ingredient/list', {});
      this.list = response.data;
      this.yunxing = 0;
      this.kongxian = 0;
      this.guzhang = 0;
      this.lixian = 0;

      for (let index = 0; index < this.list.length; index++) {
        const eq = this.list[index];
        if (eq.status == null ||eq.status == '-1') {
          this.lixian++;
        }else if (eq.status == '0') {
          this.yunxing++;
        }else if (eq.status == '1') {
          this.kongxian++;
        }else if (eq.status == '3') {
          this.guzhang++;
        }
      }
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    }
  }
};
</script>
